import React from "react";
import { useSelector } from 'react-redux';
import { useTranslation, Trans } from "react-i18next";

import {
  Modal,
  Image,
  Button
} from '@lockerpm/design';

import images from "../../assets/images";

import global from "../../config/global";
import common from "../../utils/common";
import storeActions from "../../store/actions";
import onboardingServices from "../../services/onboarding";

const WelcomeBusinessModal = () => {
  const { t } = useTranslation();
  const { WelcomeToLockerEnterpriseImg } = images;

  const welcomeBusinessVisible = useSelector((state) => state.onboarding.welcomeBusinessVisible);

  const onClose = () => {
    global.store.dispatch(storeActions.updateWelcomeBusinessVisible(false));
  }

  const offWelcome = async () => {
    await onboardingServices.update_onboarding({ vault_to_dashboard: true });
    global.store.dispatch(storeActions.updateWelcomeBusinessVisible(false));
    onClose();
  }

  const goToDashboard = () => {
    common.openNewTab(`${global.urls.LOCKER_ENTERPRISE_URL}`);
    onClose();
  }

  return (
    <Modal
      open={welcomeBusinessVisible}
      onCancel={onClose}
      width={600}
      title={<p className="text-xl text-center font-semibold">
        {t('welcome_business.title')}
      </p>}
      footer={<div className="flex items-center justify-end">
        <Button
          type="text"
          onClick={() => offWelcome()}
        >
          <p className="text-primary font-semibold">{t('welcome_business.dont_show')}</p>
        </Button>
        <Button
          type="primary"
          onClick={() => goToDashboard()}
        >
          {t('welcome_business.go_dashboard')}
        </Button>
      </div>}
      closeIcon={<></>}
    >
      <div className="flex md:flex-row flex-col items-center">
        <div className="md:w-[220px] mb-6 md:mb-0">
          <Image
            src={WelcomeToLockerEnterpriseImg}
            preview={false}
          />
        </div>
        <div className="md:flex-1 w-full md:pl-10 pl-0">
        <p className="mb-4">
          {t('welcome_business.content.text1')}
        </p>
        <ul style={{ marginLeft: -18 }}>
          {
            [1, 2, 3, 4, 5].map((item) => <li key={item}>
              {t(`welcome_business.content.note${item}`)}
            </li>)
          }
        </ul>
        <p className="mt-4">
          <Trans
            i18nKey={'welcome_business.content.text2'}
            components={{
              b: <b className="font-semibold"/>
            }}
          />
        </p>
      </div>
      </div>
    </Modal>
  );
}

export default WelcomeBusinessModal;